module.exports = __webpack_public_path__ + "static/media/mary-jane.3e6b0fe2.png";